import { createContext } from "react";

export const SortAndFilterContent = createContext({} as any);
